import React, { useMemo } from "react";
import { buildPaymentInstructionsPresentation } from "../../helpers/invoicePaymentInstructions";

/**
 * Read-only live preview of the customer-facing payment section.
 * Consumes the same presentation model as Preview/PDF.
 */
export function PaymentInstructionsLivePreview({
  value,
  variant = "admin",
}) {
  const presentation = useMemo(
    () => buildPaymentInstructionsPresentation(value),
    [value],
  );

  const isAdmin = variant === "admin";

  if (!presentation) {
    return (
      <div
        style={
          isAdmin
            ? {
                marginTop: "16px",
                padding: "14px 16px",
                borderRadius: "10px",
                border: "1px dashed rgba(255,255,255,0.18)",
                background: "rgba(0,0,0,0.18)",
              }
            : {
                marginTop: "14px",
                padding: "12px 14px",
                borderRadius: "10px",
                border: "1px dashed rgba(255,255,255,0.14)",
                background: "rgba(0,0,0,0.16)",
              }
        }
      >
        <div
          style={{
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            opacity: 0.55,
            marginBottom: "8px",
          }}
        >
          Invoice preview
        </div>
        <p
          style={{
            margin: 0,
            fontSize: "13px",
            opacity: 0.55,
            lineHeight: 1.4,
          }}
        >
          No payment instructions configured — this section will be omitted from
          the invoice.
        </p>
      </div>
    );
  }

  return (
    <div
      style={
        isAdmin
          ? {
              marginTop: "16px",
              padding: "14px 16px",
              borderRadius: "10px",
              border: "1px solid rgba(201,168,76,0.28)",
              background: "rgba(255,255,255,0.03)",
            }
          : {
              marginTop: "14px",
              padding: "12px 14px",
              borderRadius: "10px",
              border: "1px solid rgba(201,168,76,0.22)",
              background: "rgba(255,255,255,0.03)",
            }
      }
      aria-live="polite"
    >
      <div
        style={{
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          opacity: 0.55,
          marginBottom: "10px",
        }}
      >
        Invoice preview
      </div>
      <div
        style={{
          fontWeight: 700,
          fontSize: "14px",
          marginBottom: "12px",
          color: "#c9a84c",
        }}
      >
        {presentation.title}
      </div>
      {presentation.blocks.map((block, index) => {
        if (block.type === "field") {
          return (
            <div key={`preview-field-${index}`} style={{ marginBottom: "10px" }}>
              <div
                style={{
                  fontSize: "12px",
                  opacity: 0.6,
                  marginBottom: "3px",
                }}
              >
                {block.label}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  whiteSpace: "pre-wrap",
                  lineHeight: 1.4,
                }}
              >
                {block.value}
              </div>
            </div>
          );
        }

        if (block.type === "text") {
          return (
            <p
              key={`preview-text-${index}`}
              style={{
                margin: "0 0 8px",
                fontSize: "13px",
                lineHeight: 1.45,
                opacity: 0.85,
                whiteSpace: "pre-wrap",
              }}
            >
              {block.text}
            </p>
          );
        }

        return null;
      })}
    </div>
  );
}
